import React, { useState } from "react";

const testimonials = [
  {
    title: "Une révolution pour notre gestion RH !",
    name: "Fatou Diallo",
    role: "Directrice RH - Groupe SOTRACO",
    text: "DOWONOU RH a transformé notre gestion du personnel. La centralisation des profils, la gestion automatisée des congés et le suivi des documents nous font gagner 70% de temps. L'interface est intuitive et parfaitement adaptée à nos besoins africains.",
    avatar: "/images/CLIENT_1.png",
  },
  {
    title: "Plus de paperasse, plus d'efficacité !",
    name: "Amadou Traoré",
    role: "Directeur Administratif - Banque Atlantique",
    text: "Avec DOWONOU GED, nous avons dématérialisé 15 000 documents en 3 mois. La recherche instantanée et l'archivage sécurisé nous ont permis de réduire nos coûts d'archivage de 60%. C'est exactement ce dont nous avions besoin pour notre digitalisation.",
    avatar: "/images/CLIENT_2.png",
  },
  {
    title: "Une solution qui comprend nos défis !",
    name: "Kouassi N'Guessan",
    role: "CEO - Agro-Industrie CI",
    text: "DOWONOU nous accompagne dans notre transformation digitale depuis 2 ans. La gestion intégrée RH, paie et documents nous a permis d'optimiser nos processus et de nous conformer aux réglementations locales. Un partenaire de confiance !",
    avatar: "/images/CLIENT_3.png",
  },
  {
    title: "Enfin une solution adaptée à l'Afrique !",
    name: "Aïcha Bamba",
    role: "Responsable Paie - Groupe CFAO",
    text: "L'automatisation de la paie avec DOWONOU nous fait économiser 2 jours de travail par mois. L'interface est pensée pour nos réalités locales et l'équipe support est réactive. Je recommande vivement cette solution à toutes les entreprises africaines.",
    avatar: "/images/CLIENT_1.png",
  }
];

const TESTIMONIALS_PER_PAGE = 3;

const TestimonialsSection = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(testimonials.length / TESTIMONIALS_PER_PAGE);

  const startIdx = currentPage * TESTIMONIALS_PER_PAGE;
  const endIdx = startIdx + TESTIMONIALS_PER_PAGE;
  const visibleTestimonials = testimonials.slice(startIdx, endIdx);

  const handlePrev = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };
  const handleNext = () => {
    if (currentPage < totalPages - 1) setCurrentPage(currentPage + 1);
  };

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-3">
          Ce que disent nos <span className="text-blue-500">clients</span>
        </h2>
        <p className="text-center text-gray-500 max-w-2xl mx-auto mb-10">
          Découvrez comment nos clients transforment leur gestion d'entreprise avec DOWONOU. Des témoignages authentiques d'entreprises africaines qui ont choisi l'excellence.
        </p>
        <div className="flex flex-col md:flex-row gap-8 justify-center items-stretch">
          {visibleTestimonials.map((t) => (
            <div key={t.name} className="bg-white rounded-xl shadow p-6 flex flex-col max-w-sm w-full mx-auto">
              <div className="font-semibold text-lg mb-2 text-gray-900 text-left">{t.title}</div>
              <p className="text-gray-500 mb-6 text-left">{t.text}</p>
              <hr className="my-4" />
              <div className="flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-14 h-14 rounded-lg object-cover" />
                <div>
                  <div className="font-bold text-gray-900">{t.name}</div>
                  <div className="text-gray-400 text-sm">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Pagination */}
        <div className="flex justify-center mt-8 gap-2">
          <button
            className="pb-1 w-10 h-10 rounded-full bg-white border border-gray-300 text-gray-700 flex items-center justify-center text-xl shadow hover:bg-gray-100 transition disabled:opacity-50"
            onClick={handlePrev}
            disabled={currentPage === 0}
          >
            ←
          </button>
          <button
            className="pb-1 w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center text-xl shadow hover:bg-blue-600 transition disabled:opacity-50"
            onClick={handleNext}
            disabled={currentPage === totalPages - 1}
          >
            →
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection; 